import React, { useState } from "react";
import { NavBrand } from "../components/NavBrand";
import { DesktopMenu } from "./DesktopMenu/DesktopMenu";
import styles from "./DesktopNavbar.module.scss";
import { NavToggle } from "../components/NavToggle";
import { NavbarProfile } from "../NavbarProfile/NavbarProfile";
import classNames from "classnames";

export const DesktopNavbar = ({ isDesktop }) => {
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);

  return (
    <>
      <nav className={styles['dn-root']}>
        <div className={styles.container}>
          <NavToggle
            onClick={() => {
              setOffcanvasOpen((prev) => !prev);
            }}
            isOffcanvasOpen={false}
          />

          <NavBrand/>
          
          <DesktopMenu
            isDesktop={isDesktop}
            isOffcanvasOpen={isOffcanvasOpen}
            onClick={() => {
              setOffcanvasOpen((prev) => !prev);
            }}
          />

          <NavbarProfile 
            isDesktop={isDesktop}
          />
        </div>
      </nav>

      <div
        className={classNames(
          styles['offcanvas-backdrop'],
          isOffcanvasOpen ? styles['show'] : '',
        )}
        onClick={() => {
          setOffcanvasOpen((prev) => !prev);
        }}
        ></div>
    </>
  )
}